import { useEffect, useState } from "react";

/**
 * Returns a debounced copy of `value` that only updates after `delayMs` have
 * elapsed without a further change. Used to throttle draft autosave writes so
 * we serialise to storage at most once per quiet period rather than on every
 * keystroke.
 *
 * Mirrors the `setTimeout`/`clearTimeout` cleanup idiom already used in
 * `useSessionTimeout.ts` and `ReportBuilderWizard.tsx`'s inline draft persist.
 */
export function useDebounce<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
